// src/components/Footer.js
import React from 'react';
import '../App.css'; // or your main CSS file
import { DATENSTAND } from "../config/constants";

function Footer() {
  return (
    <div className="footer-container">
      
      {/* Top row: both links in one flexbox */}
      <div className="footer-top">
        <a 
          href="https://www.kr-lsa.de/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          Krebsregister Sachsen-Anhalt
        </a>

        <a 
          href="https://www.kr-lsa.de/impressum" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          Impressum
        </a>
      </div>

      {/* Bottom row */}
      <div className="footer-bottom">
        <span>Datenstand {DATENSTAND}</span>
      </div>

    </div>
  );
}

export default Footer;

